<template>
    <div id="app" class="min-w-[1024px] min-h-[100vh] flex">
        <AppAside />
        <AppMain>
            <!-- header -->
            <div>
                <h3 class="text-sm font-medium text-gray-500">FlexBen</h3>
                <h1 class="mt-1.5 text-3xl font-semibold flex items-center gap-1">Top up</h1>
            </div>

            <!-- contact -->
            <div v-if="$appUtil.checkPermission('FLEXBEN_EDIT')" class="flex justfy-btween w-full max-w-7xl min-w-[880px] h-[92px] p-[20px] border-[1px] border-[#4031B8] rounded bg-[#E1DDFF] mt-[21px]">
                <div class="w-[90%]">
                    <p class="text-[20px] text-[#4031B8] font-bold">Need to top up your wallet?</p>
                    <p class="text-[16px] text-[#4031B8]">Please contact your HRnFLEX Customer Success Representative to top up your account.</p>
                </div>
                <div>
                    <button @click="showContractPopup" class="w-[173px] h-[49px] px-[50px] py-[13px] bg-[#4031B8] text-[#fff] rounded">Contact</button>
                </div>
            </div>

            <div class="fw-full max-w-7xl mt-5">
                <div class="flex justify-between">
                    <p class="flex text-[20px] justify-center items-center">
                        Top up History
                    </p>
                </div>
            </div>

            <!-- date search -->
            <div class="fw-full max-w-7xl mt-5 mb-5">
                <div class="w-full flex justify-center">
                    <div class="w-[460px]">
                    <ElementsDateSearchPackLite
                        v-model:startDate="selectDate.startSearchDate" 
                        v-model:endDate="selectDate.endSearchDate" 
                        @searchEvent="searchSelectedDate" 
                    />
                    </div>
                </div>
            </div>
            <div class="fw-full max-w-7xl relative">
                <div class="flex justify-end">
                    <button @click="clickExcelDownload" class="w-[160px] h-[50px] leading-[38px] border-[1px] border-[#D6DDEB] text-[#6B7280] rounded-lg bg-white">
                        Excel Download
                    </button>
                </div>
            </div>

            <div class="fw-full max-w-7xl">
                <div class="mt-1">
                    <div class="mt-5 rounded-lg w-full bg-white shadow border-1 border-solid border-[#d1d5db]">
                        <div class="flex justify-between items-center h-[4rem]">
                            <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">No</h3>
                            <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">Date</h3>
                            <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">Points</h3>
                            <h3 class="py-4 text-base font-medium text-slate-500 flex-1 text-center">Balance</h3>
                        </div>
                        <div class="w-full h-px bg-gray-200"></div>
                        <div class="overflow-auto">
                            <div class="min-w-full w-fit min-h-[8rem]">
                                <template v-for="(topup, index) in topupList" v-bind:key="index">
                                    <a class="min-w-[656px] flex justify-between items-center py-2.5 w-full h-[4rem]" :class="[index % 2 !== 0 ? 'bg-slate-50' : '']">
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            <!-- {{ employee.no }} -->
                                            {{ index + 1 }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center">
                                            {{ fmtGenTimeToMMddyyyyHHmm(topup.mileageCompanyHistorySeq) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ numberWithCommas(topup.mileageVolume) }}
                                        </div>
                                        <div class="flex-1 text-sm font-normal text-center truncate">
                                            {{ numberWithCommas(topup.afterMileage) }}
                                        </div>
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="w-full h-28 flex justify-center items-center">
                        <ElementsPagination v-model="currentPage" :totalContent="topupCount" :contentsPerPage="selectDate.limit" @clickPage="afterClickPage" />
                    </div>
                </div>
            </div>
        </AppMain>
        <Teleport to="body">
            <ContractPopup v-model="showAskPopup" />
        </Teleport>
    </div>
</template>

<script>
import AppAside from '@/components/AppAside.vue';
import AppMain from '@/components/main/AppMain.vue';
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import ContractPopup from '@/pages/flex_ben/topup/contract/contract-popup.vue';
import moment from 'moment';

export default {
    components: {
        AppAside,
        AppMain,
        ElementsPagination,
        ContractPopup,
    },
    data() {
        return {
            showAskPopup: false,

            isNow: moment(),

            selectDate: {
                limit: 10,
                offset: 0,
                transactionAction: 'TOPUP',
                transactionFlow: 'IN',
                transactionTargetType: 'HRFLEX',
                startSearchDate: null,
                endSearchDate: null,
            },
            minuitOptions: Array.from(Array(6).keys()).map((min) => ({
                text: min.toString().padEnd(2, '0'),
                value: min.toString().padEnd(2, '0'),
            })),
            hourOptions: Array.from(Array(23).keys()).map((hour) => ({
                text: (hour + 1).toString().padStart(2, '0'),
                value: (hour + 1).toString().padStart(2, '0'),
            })),
            topupList: [],

            currentPage: null,
            topupCount: null,

            transactionTypeOptions: [
                { text: 'Type', value: null },
                { text: 'Top up', value: 'TOPUP_FROM_HRFLEX' },
                { text: 'Deduct', value: 'DEDUCT_TO_HRFLEX' },
                { text: 'Transfer', value: 'TRANSFER_TO_EMPLOYEE' },
                { text: 'Withdraw', value: 'DEDUCT_FROM_EMPLOYEE' },
            ],

            scrollYBackup: 0
        };
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showAskPopup;
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
    },
    mounted() {
        this.initWeeklyRange();
        this.getTotalSummary();
        this.searchSelectedDate();
    },
    methods: {
        // #추가된부분 start 
        initWeeklyRange() {
            const base = moment().local();
            const start = base.clone().startOf('isoWeek').startOf('day');
            const end = base.clone().startOf('isoWeek').add(6, 'days').endOf('day');

            this.selectDate.startSearchDate = start.toDate();
            this.selectDate.endSearchDate   = end.toDate();
        },
        toYYYYMMDD(date) {
            if (!(date instanceof Date)) return ''
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}${m}${d}`
        },
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        getTotalSummary() {
            const self = this;

            const url = self.$api('uri', 'get-total-summary');
            self.$axios
                .get(url)
                .then((res) => {
                    const resData = res.data.data;
                    self.topupSum = resData.topupSum;
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        getWhenDate(when, type) {
            const self = this;
            let startDate = null;
            let endDate = null;

            if (when == 'this') {
                if (type == 'week') {
                    startDate = moment().startOf('isoWeek').format('YYYYMMDD');
                    endDate = moment().endOf('isoWeek').format('YYYYMMDD');
                }

                if (type == 'month') {
                    startDate = moment().startOf('month').format('YYYYMMDD');
                    endDate = moment().endOf('month').format('YYYYMMDD');
                }
            }

            //last = 저번주
            if (when == 'last') {
                if (type == 'week') {
                    startDate = moment().add(-1, 'w').startOf('isoWeek').format('YYYYMMDD');
                    endDate = moment().add(-1, 'w').endOf('isoWeek').format('YYYYMMDD');
                }

                if (type == 'month') {
                    startDate = moment().add(-1, 'M').startOf('month').format('YYYYMMDD');
                    endDate = moment().add(-1, 'M').endOf('month').format('YYYYMMDD');
                }
            }

            //null exception
            if (startDate == null || endDate == null) return;

            self.getTopupHistory(startDate, endDate);

            self.currentPage = 1;
        },
        //date format must be YYYYMMDD
        getTopupHistory(startDate, endDate, offset = 0) {
            const self = this;

            const payload = {
                    ...self.selectDate,
                    startSearchDate: self.toYYYYMMDD(startDate),
                    endSearchDate: self.toYYYYMMDD(endDate),
                };
            //---------------------
            const url = self.$api('uri', 'get-topup-history');
            self.selectDate.offset = offset;

            const json_query = JSON.stringify(payload);
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    self.topupList = res.data.data.topupList;
                    self.topupCount = res.data.data.topupCount;
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        //default 가 3개월의 기록이기 때문에 3개월의 start, end 날짜구하는 부분
        //not used
        get3month() {
            const self = this;

            const monthStart = moment().add(-3, 'M').format('YYYYMMDD');
            const monthEnd = moment().format('YYYYMMDD');

            self.getTopupHistory(monthStart, monthEnd);
        },
        searchSelectedDate() {
            const self = this;

            self.getTopupHistory(self.selectDate.startSearchDate, self.selectDate.endSearchDate);
        },
        afterClickPage(item) {
            const self = this;

            //company employee 참고
            self.getTopupHistory(self.selectDate.startSearchDate, self.selectDate.endSearchDate, item);
        },
        clickExcelDownload() {
            const self = this;

            if (self.topupList.length == 0) {
                self.showExcelDisableNoti = true;
                return;
            }

            const json_query = JSON.stringify(self.selectDate);
            const url = self.$api('uri', 'get-topup-history-file');
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    const downloadLink = res.data.data.excelFilePath;
                    {
                        const aElem = document.createElement('a');
                        aElem.href = downloadLink;
                        aElem.click();
                    }
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        fmtGenTimeToMMddyyyyHHmm(genTime) {
            const yymmddhhmmss = genTime.substr(0, 12);
            return moment(yymmddhhmmss, 'YYMMDDhhmmss').format('MM/DD/YYYY HH:mm');
        },
        numberWithCommas(number) {
            if (!number) return;
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        showContractPopup() {
            const self = this;
            self.showAskPopup = true;
        },
    },
};
</script>
